import { lazy } from "react";
import { useRoutes, Navigate } from "react-router-dom";
import Layout from "../layout";
import { Login } from "../components/Login";
import { AuthProvider } from "../auth";
import HeaderComponent from "../components/Header";
import { AppProvider } from "../components/Header/context";
import { PrivacyPolicy } from "../pages/PrivacyPolicy";
import { TermsAndConditions } from "../pages/TermsAndConditions";

const Dashboard = lazy(() => import("../components/Dashboard/"));
const Forms = lazy(() => import("../components/FormComponent/ClinicalForms"));
const ParentConsent = lazy(() => import("../components/ParentConsent/"));
const EthicsConsent = lazy(() => import("../components/EthicsConsent/"));

const useRenderRoutes = () =>
  useRoutes([
    {
      path: "consent/:code",
      element: <ParentConsent />,
    },
    {
      path: "ethics-consent/:type/:code",
      element: <EthicsConsent />,
    },
    {
      element: (
        <AuthProvider>
          <AppProvider>
            <HeaderComponent />
            <Layout />
          </AppProvider>
        </AuthProvider>
      ),
      children: [
        {
          index: true,
          element: <Dashboard />,
        },
        {
          path: "forms/:formId/:responseId",
          element: <Forms />,
        },
        {
          path: "forms/:formId",
          element: <Forms />,
        },
        {
          path: "login",
          element: <Login />,
        },
        {
          path: "login/:actor",
          element: <Login />,
        },
        {
          path: "privacy-policy",
          element: <PrivacyPolicy />,
        },
        {
          path: "terms-and-conditions",
          element: <TermsAndConditions />,
        },
      ],
    },
    {
      path: "*",
      element: <Navigate to="/" replace />,
    },
  ]);

const renderRoutes = { useRenderRoutes };

export default renderRoutes;
